import type { RouteRecordRaw } from 'vue-router';

import type CrudAction from '@/features/crud/CrudAction';
import CrudActionType from '@/features/crud/CrudActionType';

const FacebookPage = async () => import('@/pages/FacebookPage.vue');
const FacebookAccountFormModal = async () =>
  import('@/features/facebook/facebook-account-form-modal/FacebookAccountFormModal.vue');
const FacebookProxiesListModal = async () =>
  import('@/features/facebook/proxies/proxies-list-modal/FacebookProxiesListModal.vue');
const FacebookProxyFormModal = async () =>
  import('@/features/facebook/proxies/proxy-form-modal/FacebookProxyFormModal.vue');

type FormModalPageProps = {
  action: CrudAction;
};

export function getFacebookRoutes(): RouteRecordRaw[] {
  return [
    {
      children: [
        {
          component: FacebookAccountFormModal,
          name: 'create-facebook-account',
          path: '/facebook/accounts/create',
          props: (): FormModalPageProps => ({
            action: {
              type: CrudActionType.CREATE,
            },
          }),
        },
        {
          component: FacebookAccountFormModal,
          name: 'edit-facebook-account',
          path: '/facebook/accounts/edit/:id',
          props: (route): FormModalPageProps => ({
            action: {
              id: route.params.id as string,
              type: CrudActionType.EDIT,
            },
          }),
        },
        {
          component: FacebookAccountFormModal,
          name: 'clone-facebook-account',
          path: '/facebook/accounts/clone/:id',
          props: (route): FormModalPageProps => ({
            action: {
              id: route.params.id as string,
              type: CrudActionType.CLONE,
            },
          }),
        },
        {
          children: [
            {
              component: FacebookProxyFormModal,
              name: 'create-facebook-proxy',
              path: '/facebook/proxies/create',
              props: (): FormModalPageProps => ({
                action: {
                  type: CrudActionType.CREATE,
                },
              }),
            },
            {
              component: FacebookProxyFormModal,
              name: 'edit-facebook-proxy',
              path: '/facebook/proxies/edit/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.EDIT,
                },
              }),
            },
            {
              component: FacebookProxyFormModal,
              name: 'clone-facebook-proxy',
              path: '/facebook/proxies/clone/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.CLONE,
                },
              }),
            },
          ],
          component: FacebookProxiesListModal,
          name: 'facebook-proxies',
          path: '/facebook/proxies',
        },
      ],
      component: FacebookPage,
      meta: {
        title: 'Facebook',
        useIn: ['navigation-tabs'],
      },
      name: 'facebook',
      path: '/facebook',
    },
  ];
}
